import { createSlice } from "@reduxjs/toolkit";
import { localStorageInstance } from "../utils/localStorage";
import { createValuePreparer } from "./reduxUtils";
import {
  addUniqueItem,
  createDefaultSearchState,
  getDefaultGridView,
  normalizeSearchText,
  removeItem,
  toggleEpicValue,
} from "./searchSliceUtils";

const isGridView = localStorageInstance.getItem("showGridView");
const initialState = createDefaultSearchState(getDefaultGridView(isGridView));

const search = createSlice({
  name: "search",
  initialState,
  reducers: {
    searchCard: {
      prepare: createValuePreparer("searchText"),
      reducer(state, action) {
        state.searchText = normalizeSearchText(action.payload.searchText);
      },
    },
    searchBoard: {
      prepare: createValuePreparer("searchText"),
      reducer(state, action) {
        state.boardSearchText = normalizeSearchText(action.payload.searchText);
      },
    },
    addBoard: {
      prepare: createValuePreparer("boardSearch"),
      reducer(state, action) {
        state.epicSearch = [];
        state.boardSearch = addUniqueItem(
          state.boardSearch,
          action.payload.boardSearch
        );
      },
    },
    removeBoard: {
      prepare: createValuePreparer("boardSearch"),
      reducer(state, action) {
        state.epicSearch = [];
        state.boardSearch = removeItem(
          state.boardSearch,
          action.payload.boardSearch
        );
      },
    },
    addEpic: {
      prepare: createValuePreparer("epicSearch"),
      reducer(state, action) {
        state.epicSearch = toggleEpicValue(
          state.epicSearch,
          action.payload.epicSearch
        );
      },
    },
    addAllBoard: {
      prepare: createValuePreparer("boardSearch"),
      reducer(state, action) {
        state.epicSearch = [];
        state.boardSearch = action.payload.boardSearch;
      },
    },
    setDateRange: {
      prepare: createValuePreparer("dateRange"),
      reducer(state, action) {
        state.dateRange = action.payload.dateRange ?? null;
      },
    },
    checkAndSetUser: {
      prepare: createValuePreparer("myTaskUser"),
      reducer(state, action) {
        state.myTaskUser = [action.payload.myTaskUser];
      },
    },
    setMyTaskUser: {
      prepare: createValuePreparer("myTaskUser"),
      reducer(state, action) {
        state.myTaskUser = action.payload.myTaskUser;
      },
    },
    addAllEpic: {
      prepare: createValuePreparer("epicSearch"),
      reducer(state, action) {
        state.epicSearch = action.payload.epicSearch;
      },
    },
    setTaskTab: {
      prepare: createValuePreparer("tab"),
      reducer(state, action) {
        state.taskTab = action.payload.tab;
      },
    },
    setGridView: {
      prepare: createValuePreparer("tab"),
      reducer(state, action) {
        state.gridView =
          typeof action.payload?.tab === "boolean"
            ? action.payload.tab
            : !state.gridView;
      },
    },
    setWorkHours: {
      prepare: createValuePreparer("hour"),
      reducer(state, action) {
        state.totalWorkHours = action.payload.hour;
      },
    },
  },
});

export const {
  searchCard,
  searchBoard,
  addBoard,
  removeBoard,
  addAllBoard,
  setDateRange,
  setMyTaskUser,
  addAllEpic,
  addEpic,
  setTaskTab,
  setGridView,
  setWorkHours,
  checkAndSetUser,
} = search.actions;

export default search.reducer;
